import Vue from 'vue';
import { component, getter, prop } from '../../../decorators';

import { CLIP_TYPE_CODE } from '../../../config';
import { ADD_TO_CART } from '../../../store/actions';

import AddToCart from '../../../components/add-to-cart/add-to-cart.vue';
import ShowDialogueModal from './show-dialogue-modal/show-dialogue-modal.vue';

import ComponentCreator from '../../../helpers/component.creator';

import countOf from '../../../helpers/dom/countOf';

import l10n from '@/transformers/l10n';

import {
   CLIPS_DOWNLOAD
} from '@/store/actions';

@component({
   components: { AddToCart }
})
export default class RowClips extends Vue {
   @prop({ type: [String, Number] }) selected

   @getter() getLoadedClips

   @getter('getCurrentShowId') showId

   @getter() language

   details(video) {
      this.$emit('details', video);
   }

   duration(video) {
      return video.duration;
   }

   isClip(video) {
      return video.type === CLIP_TYPE_CODE;
   }

   normalize(metadata) {
      return metadata.map(m => m.name).join(', ');
   }

   addTo(clip, cart) {
      this.$store.dispatch(ADD_TO_CART, { cart, clip });
   }

   matchCount(dialogue) {
      return countOf(dialogue);
   }

   async showDialogueModal(dialogue) {
      try {
         await ComponentCreator.dialog(ShowDialogueModal, { dialogue });
      } catch (e) {
         // noop
      }
   }

   download(clipId) {
      this.$store.dispatch(CLIPS_DOWNLOAD, { rootTitleId: this.showId, clipId, language: this.language });
   }

   get downloadTitle() {
      return l10n('cart.download_mxf');
   }
}
